import { render, staticRenderFns } from "./LoginFlow.vue?vue&type=template&id=64aff514"
import script from "./LoginFlow.vue?vue&type=script&lang=ts"
export * from "./LoginFlow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports